import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import ToastContext from '../contexts/ToastContext';
import './Auth.css';
import backgroundImage from '../assets/imagem-prefeitura.jpg';
import { FaEnvelope, FaPaperPlane } from 'react-icons/fa';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const { addToast } = useContext(ToastContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      addToast(data.message, 'success');
    } catch (error) {
      addToast(error.response?.data?.message || 'Erro ao solicitar recuperação.', 'error');
    }
  };

  return (
    <div className="auth-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="auth-card">
        <h1>Recuperar Senha</h1>
        <p>Insira seu e-mail para receber o link de recuperação.</p>
        <form onSubmit={handleSubmit} className="form-modern">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div>
              <FaEnvelope />
              <input
                type="email"
                id="email"
                placeholder="Digite seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="form-actions full-width">
            <button type="submit" className="btn-modern">
              <FaPaperPlane size={20} />
              <span>Enviar</span>
            </button>
          </div>
          <div className="auth-links">
            <p>
              Lembrou a senha? <Link to="/login">Voltar para o login</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;